import { createFileRoute } from '@tanstack/react-router'
import { JobDetailPage } from '@/features/smart-search/job-detail'

function RouteComponent() {
  const { searchId, jobId } = Route.useParams()
  return <JobDetailPage jobId={jobId} ctx={{ kind: 'smart-search', searchId }} />
}

export const Route = createFileRoute(
  '/_authenticated/company-jobs/smart-search/$searchId/job/$jobId/'
)({
  component: RouteComponent,
})
